//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'online_service',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};